import { useParams } from "react-router-dom";
import { useGetRemittancePaymentDetailQuery } from "../../../../store/queries/remittance";

const usePaymentDetail = () => {
  const { remittanceID } = useParams();
  const { data: paymentData, isFetching } =
    useGetRemittancePaymentDetailQuery({
      remittance_id: remittanceID,
    });

  const pData = paymentData?.data;

  const formatLabel = (key) =>
    key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());

  const paymentValues = pData
    ? [
        ...Object.keys(pData)
          .filter(
            (key) =>
              key !== "permissions" &&
              key !== "transactions" &&
              key !== "rate_lock" &&
              typeof pData[key] !== "object"
          )
          .map((key) => ({
            label: formatLabel(key),
            value: `${pData[key] ?? "Not specified"}`,
          })),
        ...(pData.rate_lock
          ? Object.keys(pData.rate_lock)
              .filter((key) => key !== "applied" && key !== "locked_rate")
              .map((key) => ({
                label: `Rate Lock ${formatLabel(key)}`,
                value: `${pData.rate_lock[key] ?? "Not specified"}`,
              }))
          : []),
      ]
    : [];

  const transactions = pData?.transactions || [];

  const transactionFields = {
    transaction_id: { label: "Transaction ID", sortable: false },
    purpose: { label: "Purpose", sortable: false },
    amount: { label: "Amount", sortable: false },
    status: { label: "Status", sortable: false },
    date: { label: "Date", sortable: false },
  };

  return {
    paymentValues,
    transactions,
    transactionFields,
    isFetching,
  };
};

export default usePaymentDetail;
